Vendd.Scripts.load(function () {


    var controlBase = function (element, definition) {

        this.element = element;
        this.definition = definition;

    };
    controlBase.prototype.name = 'controlBase';

    controlBase.prototype.init = function ()
    {
        return Vendd.Promises.Default;
    };

    controlBase.prototype.build = function ()
    {
        return Vendd.Promises.Default;
    };

    controlBase.prototype.render = function () {

        var self = this;

        self.element.addClass('ctl');
        self.element.addClass(`ctl-${self.name}`);

        return Vendd.Promises.Default;
    };

    controlBase.prototype.bind = function ()
    {
        return Vendd.Promises.Default;
    };

    controlBase.prototype.findParent = function (lambda) {

        var self = this;

        if (typeof lambda === 'string') {

            return self.findParent(function (x) { x.id === lambda });

        }

        if (typeof lambda === 'function') {

            var node = self;
            var allNodes = [];

            while (true) {

                allNodes.push(node);

                if (node.parent === undefined) {

                    break;

                }

                node = node.parent;

            }

            return _.find(allNodes, lambda);

        }

        throw new Error('Invalid lambda');
    }

    controlBase.prototype.getForm = function () {

        var self = this;

        return self.findParent(function (x) { return x instanceof Vendd.inlineEdit.formControlBase; });

    }

    var Vendd = window.Vendd || {};

    Vendd.inlineEdit.controls = {}
    Vendd.inlineEdit.controlBase = controlBase;

});